import { render } from "./Mosaic.vue?vue&type=template&id=ec71a8b8"
import script from "./Mosaic.vue?vue&type=script&lang=js"
export * from "./Mosaic.vue?vue&type=script&lang=js"

import "./Mosaic.vue?vue&type=style&index=0&id=ec71a8b8&lang=scss"

import exportComponent from "/Users/sarah.veysset/S/TRAVAIL/FREELANCE/OSTEO BARRY/osteo-barry/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__